import { Box, BoxProps, Flex } from "@chakra-ui/react";
import React, { useMemo } from "react";

import { secondsToHHMMSS } from "../../../utils/media";

export type CurrentTimeProps = BoxProps & {
  time: number;
  duration: number | undefined;
};

const CurrentTime: React.FC<CurrentTimeProps> = ({
  time,
  duration,
  ...styles
}) => {
  const timeStr = useMemo(() => secondsToHHMMSS(time), [Math.floor(time)]);
  const durationStr = useMemo(() => secondsToHHMMSS(duration), [duration]);

  return (
    <Flex color="white" fontSize="sm" fontWeight="medium" {...styles}>
      {duration && (
        <>
          <Box>{timeStr}</Box>
          &nbsp;/&nbsp;
        </>
      )}
      <Box>{durationStr}</Box>
    </Flex>
  );
};

export default CurrentTime;
